import * as React from "react"

import {formatProductsUnits} from "@ui-seeker/utils";
import { HierarchicalTextBlock } from "@components"


export default function reachColumn() {
    return [{
        name: 'shareViews', label: 'Reach',
        options: {
            filter: false,
            setCellHeaderProps: () => ({
                sx: { minWidth: 200 }
            }),
            customBodyRowRender: (value, row) => {
                return  <HierarchicalTextBlock
                    supertitle="nº product views:"
                    supertitleValue={formatProductsUnits(value)}
                    title="nº section page views:"
                    titleValue={formatProductsUnits(row.sectionsVisits)}
                    subtitle="nº retailer pages views:"
                    subtitleValue={formatProductsUnits(row.visitsSite)}
                />
            }
        }
    }]
}